/**
 * Checks if a value is null or undefined.
 *
 * @param value - The value to check
 * @returns `true` if the value is null or undefined, `false` otherwise
 *
 * @example
 * isNil(null) // => true
 * isNil(undefined) // => true
 * isNil(0) // => false
 * isNil('') // => false
 * isNil(false) // => false
 * isNil({}) // => false
 */
export const isNil = (value: unknown): value is null | undefined => {
  return value === null || value === undefined;
};
